import type { RouteLocationNormalized } from 'vue-router'
import { includes, isArray, some, startsWith, filter } from 'lodash'
import { plainToInstance } from 'class-transformer'
import useApi from '@/composables/api'
import queryClient from '@/plugins/query'
import { QUERY_KEYS } from '@/constants/query'
import MeResource from '@/services/api/transformers/MeResource'

const { api } = useApi()

export default async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
    if (to.meta.feature) {
        const { data } = await queryClient.ensureQueryData({
            queryKey: QUERY_KEYS.me,
            queryFn: () => api.authorizationLoggedInUser.getMe()
        })
        const features = isArray(to.meta.feature) ? to.meta.feature : [to.meta.feature]

        // Filter out tithely-giving as it's handled separately
        const databaseFeatureFlags = filter(features, f => f !== 'tithely-giving')

        // Check if user has ANY of the other features enabled for the route
        // also check for optional negation "!" prefix to exclude a feature
        to.meta.hasFeature =
            databaseFeatureFlags.length > 0
                ? some(databaseFeatureFlags, (feature: string) =>
                      startsWith(feature, '!')
                          ? !includes(data?.features, feature.slice(1))
                          : includes(data?.features, feature)
                  )
                : true

        // Special handling for tithely-giving feature flag
        if (includes(features, 'tithely-giving')) {
            const me = plainToInstance(MeResource, data)
            const hasGiving = !!me?.organization?.tithelyGiving

            // AND with existing hasFeature to preserve other feature checks
            to.meta.hasFeature = to.meta.hasFeature && hasGiving
        }

        if (!to.meta.hasFeature && to.meta.isLegacyRoute !== true) {
            return from
        }
    } else {
        to.meta.hasFeature = undefined
    }
}
